import CompanyOverviewSubPage from "./company-owerview-sub-page";

const SubPage = {
  OverView: CompanyOverviewSubPage,
};

export default SubPage;
